<template>
  <!-- <el-carousel indicator-position="outside">
    <el-carousel-item v-for="item in 4" :key="item">
      <h3>{{ item }}</h3>
      <img src="">
    </el-carousel-item>
  </el-carousel> -->
  <el-carousel
    trigger="click"
    height="300px"
    :interval="3000"
    arrow="always"
    style="width:100%"
  >
    <el-carousel-item v-for="item in imglist" :key="item.name">
      <img
        v-bind:src="item.src"
        style="height:100%;width:100%;"
        alt=""
        :title="item.title"
      />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      imglist: [
        {
          name: "1",
          src: "https://dyapi.dingyang.net/public/files/images/1-1.png",
          title: "这是第一张"
        },
        {
          name: "2",
          src: "https://dyapi.dingyang.net/public/files/images/1-2.png",
          title: "这是第二张"
        },
        {
          name: "3",
          src: "https://dyapi.dingyang.net/public/files/images/1-3.png",
          title: "这是第三张"
        },
        {
          name: "4",
          src: "https://dyapi.dingyang.net/public/files/images/1-4.png",
          title: "这是第四张"
        }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style>
/* .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  } */
</style>



// WEBPACK FOOTER //
// src/components/ppt.vue